import React, { useState, useEffect } from 'react'
import { getFormTracker, getProfile } from "../../../services/PharmacyUser";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
const FormsActionsHistory = (props) => {
    const {form } = props
      const [rows, setRows] = useState([]);

      const columns = [
        { field: "id", headerName: "ID", width: 70 },
        { field: "actionDate", headerName: "Action Date", width: 180 },
        { field: "actionType", headerName: "Action Type", width: 130 },
        { field: "actionUser", headerName: "Action User ID", width: 120 },
        { field: "formId", headerName: "Form ID", width: 100 },
        { field: "actionDetails", headerName: "Action Details", width: 200 },
        { field: "firstName", headerName: "First Name", width: 130 },
        { field: "lastName", headerName: "Last Name", width: 130 },
        { field: "email", headerName: "Email", width: 200 },
        { field: "phone", headerName: "Phone", width: 150 },
        { field: "type", headerName: "User Type", width: 150 },
        {
          field: "active",
          headerName: "Active Status",
          width: 120,
          type: "boolean",
        },
      ];

    const handleGetFormActions = () => {

        getFormTracker(form.ID)
          .then((res) => {
            console.log(res);
          let dataToadd =  res.data.map(async (el) => {
              const res = await getProfile(el.actionUser);
              console.log(res.data.data.user[0]);
              el.firstName = res.data.data.user[0].first;
              el.lastName = res.data.data.user[0].last;
              el.email = res.data.data.user[0].email;
              el.phone = res.data.data.user[0].phone;
              el.type = res.data.data.user[0].type;
              el.active = res.data.data.user[0].active;

              return el;
            });
            Promise.all(dataToadd).then((res) => {
              console.log(res);
              setRows(res);
            })
           
          })
          .catch((err) => {
            console.error(err);
          });

    }

    useEffect(() => {
        console.log(form)
        if (form.ID){
          handleGetFormActions();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form])

    
  const paginationModel = { page: 0, pageSize: 50 };
console.log(rows)
  return (
    <div className="container-fluid">
      <DialogTitle id="alert-dialog-title">
        History of {form.json.title} Form.
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            checkboxSelection
            sx={{ border: 0, height: "100%", width: "100%" }}
            slots={{ toolbar: GridToolbar }}
          />
        </DialogContentText>
      </DialogContent>
    </div>
  );
}

export default FormsActionsHistory